import { useState } from "react";

// components
import { ClipboardCopy } from "shared/pipes/clipboard-copy";
import { TitleSection, ActionSection, InfoSection } from "../headers";


const ItemFigure = ({ item, ...props }) => {
    const [isDeleted, setDeleted] = useState(false);
    const [currentItem, setCurrentItem] = useState(item);

    const onDelete = () => {
        setDeleted(true);
    }

    const onSwap = (newItem) => {
        setCurrentItem(newItem);
    }

    if (isDeleted) { return null; }

    return (
        <>
            <div id={currentItem.barcode}>
                <TitleSection item={currentItem} />
                <InfoSection item={currentItem} box={props.box} />

                <div className="card-image">
                    <ClipboardCopy value={currentItem.barcode}>
                        <figure className="image">
                            <img src={currentItem.imageURL} alt={currentItem.barcode} />
                        </figure>
                    </ClipboardCopy>
                </div>

                <ActionSection item={currentItem} onDelete={onDelete} onSwap={onSwap} {...props} />
            </div>
        </>
    );
}

export { ItemFigure as EditItemFigure };
